import * as _4 from 'lodash4';
import { TransferCreditsProgressState } from './../../progression/transfer_credits_progress_state';
import { TransferExamTypeWithExamsQuery } from './../../queries/transfer_exam_type_with_exams_query';
import { IDisplayMessageService } from '../../../global/services/display_message_service';
import { SitesetupConfiguration } from '../../../../lib/sitesetup/config/sitesetup_configuration';

export class TransferExamCreditsController {
  headerText?: string;
  description?: string;
  descriptionLink?: boolean;

  constructor(
    private ngTransferCreditsProgressState: TransferCreditsProgressState,
    private ngTransferExamTypeWithExamsQuery: TransferExamTypeWithExamsQuery,
    private ngDisplayMessageService: IDisplayMessageService,
    private ngSitesetupConfiguration: SitesetupConfiguration
  ) {
    const otherCreditsDescriptionMessage = this.ngDisplayMessageService('other_credits_description');
    this.headerText = this.ngDisplayMessageService('other_credits_header').text;
    this.description = otherCreditsDescriptionMessage.text;
    this.descriptionLink = otherCreditsDescriptionMessage.add_contact_counselor_link;
  }

  getCorrectlyCapitalizedLinkText(): string {
    const msg = (new DOMParser()).parseFromString(this.description || '', 'text/html').textContent,
      msgSentenceEnded = _4.isString(msg) && msg.slice(-1) === '.',
      correctlyCapitalizedCharacter = msgSentenceEnded ? 'C' : 'c';
    return `${correctlyCapitalizedCharacter}ontact a counselor`;
  }
}
angular.module('capability-ng-transfer').controller('ngTransferExamCreditsController', TransferExamCreditsController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/exam_credits/exam_credits.ts